import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, Table } from "react-bootstrap";
import ReactQuill from "react-quill";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import api from "../../../api";
import "react-quill/dist/quill.snow.css";

const WarrantyCards = () => {
 const { id } = useParams();
 const navigate = useNavigate();

 const [products, setProducts] = useState([]);
 const [client, setClient] = useState("");
 const [refNo, setRefNo] = useState("");
 const [rows, setRows] = useState([]);
 const [subject, setSubject] = useState("");
 const [topContent, setTopContent] = useState("");
 const [bottomContent, setBottomContent] = useState("");
 const [warrantyDate, setWarrantyDate] = useState(new Date().toISOString().split("T")[0]);

 const [testCertificates, setTestCertificates] = useState([]);
 const [selectedTC, setSelectedTC] = useState(null);

 const durationOptions = [
 { value: "1yr", label: "1 Year" },
 { value: "18mo", label: "18 Months" },
 { value: "2yr", label: "2 Years" },
 { value: "3yr", label: "3 Years" },
 { value: "5yr", label: "5 Years" },
 { value: "life", label: "Lifetime" },
 ];

 const typeOptions = [
 { value: "std", label: "Standard" },
 { value: "ltd", label: "Limited" },
 { value: "prem", label: "Premium" },
 { value: "repl", label: "Replacement" },
 { value: "eol", label: "EOL" },
 ];

 const coverageOptions = [
 { value: "hw", label: "Hardware" },
 { value: "elec", label: "Electronic" },
 { value: "full", label: "Full" },
 { value: "unit", label: "Unit" },
 { value: "support", label: "Support Only" },
 ];

 const serviceOptions = [
 { value: "rtf", label: "RTF" },
 { value: "onsite", label: "Onsite" },
 { value: "replace", label: "Replace" },
 { value: "no-support", label: "No Support" },
 ];

 useEffect(() => {
 fetchProducts();
 fetchTestCertificates();
 }, []);

 const fetchTestCertificates = async () => {
 try {
 const res = await api.get("/test-certificates");
 if (res.data.success) setTestCertificates(res.data.data);
 } catch (err) {
 console.error(err);
 }
 };

 const handleTCChange = (selected) => {
 setSelectedTC(selected);
 const tc = testCertificates.find(t => t._id === selected.value);
 if (tc) {
 setClient(tc.client || "");
 setSubject(`Warranty Confirmation for ${tc.subject || "Equipment"}`);
 setRefNo(tc.refNo || "");
 
 const tcItems = tc.items.map(item => ({
 product: item.product?._id || item.product,
 productOption: { value: item.product?._id || item.product, label: item.productName },
 productName: item.productName,
 modelNo: item.modelNo,
 qty: item.qty,
 serialFrom: item.serialFrom,
 serialTo: item.serialTo,
 duration: "1yr",
 warrType: "std",
 coverage: "hw",
 service: "rtf",
 warrantyCode: "cs-warr-1yr-std-hw-rtf"
 }));
 setRows(tcItems);
 }
 };

 const updateWarrantyCode = (index, field, value) => {
 const newRows = [...rows];
 newRows[index][field] = value;
 const { duration, warrType, coverage, service } = newRows[index];
 newRows[index].warrantyCode = `cs-warr-${duration}-${warrType}-${coverage}-${service}`;
 setRows(newRows);
 };

 useEffect(() => {
 if (id && products.length) {
 fetchWarrantyCard();
 }
 }, [id, products]);

 const fetchProducts = async () => {
 try {
 const res = await api.get("/products");
 if (res.data.success) setProducts(res.data.data);
 } catch (err) {
 console.error(err);
 }
 };

 const fetchWarrantyCard = async () => {
 try {
 const res = await api.get(`/warranty-cards/${id}`);
 if (res.data.success) {
 const card = res.data.data;
 setClient(card.client || "");
 setRefNo(card.refNo || "");
 setSubject(card.subject || "");
 setTopContent(card.topContent || "");
 setBottomContent(card.bottomContent || "");
 setWarrantyDate(card.warrantyDate ? new Date(card.warrantyDate).toISOString().split("T")[0] : "");
 
 if (card.testCertificate) {
 setSelectedTC({ value: card.testCertificate, label: `Ref: ${card.refNo || "TC"}` });
 }

 const formattedRows = card.items.map(item => ({
 product: item.product?._id || item.product,
 productOption: { value: item.product?._id || item.product, label: item.productName },
 productName: item.productName,
 modelNo: item.modelNo,
 qty: item.qty,
 serialFrom: item.serialFrom,
 serialTo: item.serialTo,
 duration: item.duration || "1yr",
 warrType: item.warrType || "std",
 coverage: item.coverage || "hw",
 service: item.service || "rtf",
 warrantyCode: item.warrantyCode || `cs-warr-${item.duration || "1yr"}-${item.warrType || "std"}-${item.coverage || "hw"}-${item.service || "rtf"}`
 }));
 setRows(formattedRows);
 }
 } catch (err) {
 console.error(err);
 }
 };

 const productOptions = products.map(p => ({
 value: p._id,
 label: `${p.productName} (${p.modelNo})`,
 productName: p.productName,
 modelNo: p.modelNo
 }));

 const tcOptions = testCertificates.map(t => ({
 value: t._id,
 label: `${t.refNo || "No Ref"} - ${t.subject} (${t.client?.split("\n")[0]})`
 }));

 const addRow = () => {
 setRows([...rows, {
 product: null,
 productOption: null,
 productName: "",
 modelNo: "",
 qty: "",
 serialFrom: "",
 serialTo: "",
 duration: "1yr",
 warrType: "std",
 coverage: "hw",
 service: "rtf",
 warrantyCode: "cs-warr-1yr-std-hw-rtf"
 }]);
 };

 const removeRow = (index) => {
 setRows(rows.filter((_, i) => i !== index));
 };

 const handleRowChange = (index, field, value) => {
 const newRows = [...rows];
 if (field === "product") {
 newRows[index].product = value.value;
 newRows[index].productOption = value;
 newRows[index].productName = value.productName;
 newRows[index].modelNo = value.modelNo;
 } else if (field === "warrantyCode") {
 newRows[index].warrantyCode = value.value;
 newRows[index].warrantyOption = value;
 } else {
 newRows[index][field] = value;
 }

 if (field === "serialFrom" || field === "serialTo") {
 const from = newRows[index].serialFrom;
 const to = newRows[index].serialTo;
 if (from && to) {
 const fromNums = from.match(/\d+/g);
 const toNums = to.match(/\d+/g);
 if (fromNums && toNums && fromNums.length === toNums.length) {
 let diffIdx = -1;
 for (let i = 0; i < fromNums.length; i++) {
 if (fromNums[i] !== toNums[i]) diffIdx = i;
 }
 if (diffIdx !== -1) {
 const startNumStr = fromNums[diffIdx];
 const endNumStr = toNums[diffIdx];
 const start = parseInt(startNumStr);
 const end = parseInt(endNumStr);
 if (!isNaN(start) && !isNaN(end)) newRows[index].qty = end - start + 1;
 } else if (from === to) {
 newRows[index].qty = 1;
 }
 }
 }
 }
 setRows(newRows);
 };

 const generateSerialNumbers = (from, to) => {
 if (!from || !to) return "";
 const fromNums = from.match(/\d+/g);
 const toNums = to.match(/\d+/g);
 if (!fromNums || !toNums || fromNums.length !== toNums.length) return from === to ? from : `${from} to ${to}`;
 let diffIdx = -1;
 for (let i = 0; i < fromNums.length; i++) {
 if (fromNums[i] !== toNums[i]) diffIdx = i;
 }
 if (diffIdx === -1) return from;
 const startNumStr = fromNums[diffIdx];
 const endNumStr = toNums[diffIdx];
 const start = parseInt(startNumStr);
 const end = parseInt(endNumStr);
 if (isNaN(start) || isNaN(end) || start > end) return `${from} to ${to}`;
 let count = 0;
 const template = from.replace(/\d+/g, (match) => {
 if (count++ === diffIdx) return "__SERIAL__";
 return match;
 });
 const padding = startNumStr.length;
 let arr = [];
 const maxSerials = Math.min(end, start + 500);
 for (let i = start; i <= maxSerials; i++) {
 const currentNumStr = String(i).padStart(padding, '0');
 arr.push(template.replace("__SERIAL__", currentNumStr));
 }
 if (end > start + 500) arr.push("...");
 return arr.join(", ");
 };

 const saveWarrantyCard = async () => {
 const payload = {
 testCertificate: selectedTC?.value,
 client, refNo, subject, warrantyDate, topContent, bottomContent,
 items: rows.map(r => ({
 product: r.product, productName: r.productName, modelNo: r.modelNo,
 qty: r.qty, serialFrom: r.serialFrom, serialTo: r.serialTo, 
 warrantyCode: r.warrantyCode, duration: r.duration, warrType: r.warrType,
 coverage: r.coverage, service: r.service
 }))
 };
 try {
 if (id) {
 await api.patch(`/warranty-cards/${id}`, payload);
 swal("Updated", "Warranty card updated successfully", "success");
 } else {
 await api.post("/warranty-cards", payload);
 swal("Saved", "Warranty card created successfully", "success");
 }
 navigate("/warranty-cards-list");
 } catch (err) {
 console.error(err);
 swal("Error", "Failed to save warranty card", "error");
 }
 };

 return (
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between">
 <h4>{id ? "Edit Warranty Card" : "Add Warranty Card"}</h4>
 <Button variant="secondary" onClick={() => navigate("/warranty-cards-list")}>Back</Button>
 </Card.Header>
 <Card.Body>
 <Form.Group className="mb-4">
 <Form.Label>Select Test Certificate (Optional)</Form.Label>
 <Select 
 options={tcOptions} 
 value={selectedTC} 
 onChange={handleTCChange} 
 placeholder="Choose TC to auto-fill details..."
 isClearable
 />
 <Form.Text className="text-muted">Selecting a TC will auto-fill client, subject, and product list from the certificate.</Form.Text>
 </Form.Group>

 <Form.Group className="mb-3">
 <Form.Label>Client</Form.Label>
 <Form.Control as="textarea" rows={3} value={client} onChange={(e) => setClient(e.target.value)} placeholder="Enter Client Name" />
 </Form.Group>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Warranty Date</Form.Label>
 <Form.Control type="date" value={warrantyDate} onChange={(e) => setWarrantyDate(e.target.value)} />
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Reference (Ref)</Form.Label>
 <Form.Control value={refNo} onChange={(e) => setRefNo(e.target.value)} placeholder="Enter Reference" />
 </Form.Group>
 </Col>
 </Row>
 <Form.Group className="mb-3">
 <Form.Label>Subject</Form.Label>
 <Form.Control value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Enter Subject" />
 </Form.Group>
 <Form.Group className="mb-4">
 <Form.Label>Introduction Content</Form.Label>
 <ReactQuill value={topContent} onChange={setTopContent} />
 </Form.Group>
 <div style={{ overflowX: "auto", minHeight: "350px" }}>
 <Table bordered className="warranty-card-table" style={{ minWidth: "1800px" }}>
 <thead style={{ backgroundColor: "#ffd0a7" }}>
 <tr>
 <th>SR.NO</th>
 <th>QTY</th>
 <th>PRODUCT NAME</th>
 <th>Model Number</th>
 <th>Serial From</th>
 <th>Serial To</th>
 <th style={{ minWidth: "150px" }}>Duration</th>
 <th style={{ minWidth: "150px" }}>Type</th>
 <th style={{ minWidth: "150px" }}>Coverage</th>
 <th style={{ minWidth: "150px" }}>Service</th>
 <th style={{ minWidth: "250px" }}>Generated Warranty PID</th>
 <th>Action</th>
 </tr>
 </thead>
 <tbody>
 {rows.map((row, index) => (
 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#bae8ff" : "#ffffff" }}>
 <td>{index + 1}</td>
 <td><Form.Control style={{ width: "70px" }} value={row.qty} onChange={(e) => handleRowChange(index, "qty", e.target.value)} /></td>
 <td style={{ minWidth: "350px" }}>
 <Select options={productOptions} value={row.productOption} onChange={(selected) => handleRowChange(index, "product", selected)} placeholder="Select Product" />
 </td>
 <td><Form.Control value={row.modelNo} readOnly /></td>
 <td style={{ minWidth: "200px" }}><Form.Control value={row.serialFrom} onChange={(e) => handleRowChange(index, "serialFrom", e.target.value)} /></td>
 <td style={{ minWidth: "200px" }}><Form.Control value={row.serialTo} onChange={(e) => handleRowChange(index, "serialTo", e.target.value)} /></td>
 <td>
 <Select 
 options={durationOptions} 
 value={durationOptions.find(o => o.value === row.duration)} 
 onChange={(s) => updateWarrantyCode(index, "duration", s.value)} 
 />
 </td>
 <td>
 <Select 
 options={typeOptions} 
 value={typeOptions.find(o => o.value === row.warrType)} 
 onChange={(s) => updateWarrantyCode(index, "warrType", s.value)} 
 />
 </td>
 <td>
 <Select 
 options={coverageOptions} 
 value={coverageOptions.find(o => o.value === row.coverage)} 
 onChange={(s) => updateWarrantyCode(index, "coverage", s.value)} 
 />
 </td>
 <td>
 <Select 
 options={serviceOptions} 
 value={serviceOptions.find(o => o.value === row.service)} 
 onChange={(s) => updateWarrantyCode(index, "service", s.value)} 
 />
 </td>
 <td>
 <Form.Control value={row.warrantyCode} readOnly className="fw-bold text-primary" />
 </td>
 <td><Button variant="danger" size="sm" onClick={() => removeRow(index)}>Remove</Button></td>
 </tr>
 ))}
 </tbody>
 </Table>
 </div>
 <Button onClick={addRow} className="me-3">Add Row</Button>
 <Button variant="success" onClick={saveWarrantyCard} className="me-3">{id ? "Update Card" : "Save Card"}</Button>
 <Form.Group className="mt-4">
 <Form.Label>Terms & Conditions</Form.Label>
 <ReactQuill value={bottomContent} onChange={setBottomContent} />
 </Form.Group>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 );
};

export default WarrantyCards;
